import getLocalizedCurrency from "@insite/client-framework/Common/Utilities/getLocalizedCurrency";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, CreateDataForUnparse } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";
import { getCurrentLanguage } from "@store/Store/Context/ContextSelectors";

replaceInChain(chain, CreateDataForUnparse, props => {
    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }

    const language = getCurrentLanguage(props.getState()); // Poolcorp Custom Code

    props.dataForUnparse = {
        fields: [
            translate("Product Number"),
            translate("Quantity"),
            translate("MFG #"),
            translate("Unit of Measure"),
            translate("Brand"),
            translate("Title"),
            translate("Price"),
            translate("Notes"),
            translate("Added on"),
            translate("Added by"),
        ],
        data: wishListLineCollection.map(o => [
            o.erpNumber,
            o.qtyOrdered.toString(),
            o.manufacturerItem,
            o.unitOfMeasure,
            o.brand?.name || "",
            o.shortDescription,
            o.quoteRequired ? "" : language ? getLocalizedCurrency({ amount: o.pricing?.unitRegularPrice || 0, language, currencySymbol: "" }) : "", // Poolcorp Custom Code
            o.notes,
            o.createdOn.toString(),
            o.createdByDisplayName,
        ]),
    };
});